/* codul-cart.js — AJAX add-to-cart for the custom codul buy buttons.
   Replicates Dawn's product-form behaviour so the theme's cart popup
   (cart-notification: "Vezi coșul" / "Continuă cumpărăturile") opens,
   instead of redirecting to the /cart page. Progressive enhancement:
   if anything fails, the native form POST to /cart still works. */
(function () {
  if (window.__codulCartInit) return;
  window.__codulCartInit = true;

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function addUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.codul-form, .codul-coll__form') : null;
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;

    var cart = getCart();
    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {                 // e.g. sold out / error
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          return;
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (cart && typeof cart.renderContents === 'function') {
          try { cart.renderContents(data); }        // opens the Dawn cart popup
          catch (err) { window.location = root + 'cart'; }  // safety net
        } else {
          window.location = root + 'cart';
        }
      })
      .catch(function () { form.submit(); })        // hard fallback: native POST
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
      });
  });
})();
